<script>
import appConfig from "@/app.config";

import { notificationMethods, layoutMethods } from "@/state/helpers";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  },
  mounted() {
      this.changeLoaderValue({loader:true});
      this.$store.commit('auth/setContacto');
      this.$store.dispatch('rutEmpresa/getEmpresas', this.$store.getters["auth/contacto"].identificador)
      .then(() => this.changeLoaderValue({loader:false}));

  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    }
  },
  methods: {
    ...layoutMethods,
    clearNotification: notificationMethods.clear
  }
};
</script>

<template>
  <div id="app">
    <RouterView :key="$route.fullPath"/>
  </div>
</template>

<style lang="scss">
.pagination.portal.b-pagination{
  .page-item.active{
    .page-link{
      background-color: #f46a6a;
    }
  }
}
.titleTable{
  background: #e2231a !important;
  color: white !important;
}
.links{
  color: #556ee6;
  cursor: pointer;
}
.links:hover{
  color: blue;
}
a{
  color: #556ee6;
}
a:hover{
  color: blue;
}
</style>